import React from "react";
import { StyledLoader, StyledLoaderContainer } from "./StyledLoader";

const Loader = () => {
  return (
    <StyledLoaderContainer>
      <StyledLoader></StyledLoader>
    </StyledLoaderContainer>
  );
};

export default Loader;
